import projects from "Assets/svg/menu/Back_nv.svg";
import invoices from "Assets/svg/menu/Invoice_nv.svg";
import construction from "Assets/svg/menu/Manufacturing_nv.svg";
import design from "Assets/svg/menu/Designing_nv.svg";
import contract from "Assets/svg/menu/Contract_nv.svg";
import profit from "Assets/svg/menu/profitLoss_nv.svg";


export const projectMenuItems = [{
    menu_title: "profit",
    menu_icon: profit,
    path: "/dashboard/projects/profit",
    action: '',
    authorize: true,
    checkVisible: false,
    active: true,
    keyStorage: "",
    userAccess: ["1", "2", "3","5"],
    class: '',
},{
    menu_title: "construction",
    menu_icon: construction,
    path: "/dashboard/projects/construction",
    action: '',
    authorize: true,
    checkVisible: false,
    active: true,
    keyStorage: "",
    userAccess: ["1", "2", "3","5"],
    class: '',
},{
    menu_title: "contract",
    menu_icon: contract,
    path: "/dashboard/projects/contract",
    action: '',
    authorize: true,
    checkVisible: false,
    active: true,
    keyStorage: "",
    userAccess: ["1", "2", "3","5"],
    class: '',
},{
    menu_title: "invoices",
    menu_icon: invoices,
    path: "/dashboard/projects/invoices",
    action: '',
    authorize: true,
    checkVisible: false,
    active: true,
    keyStorage: "",
    userAccess: ["1", "2", "3","5"],
    class: '',
},{
    menu_title: "design",
    menu_icon: design,
    path: "/dashboard/projects/design",
    action: '',
    authorize: true,
    checkVisible: false,
    active: true,
    keyStorage: "",
    userAccess: ["1", "2", "3","5"],
    class: '',
},{
    // menu_title: "projectsListMenu",
    menu_title: "changeProjects",
    menu_icon: projects,
    path: "/dashboard/projects/list",
    action: 'projectShow',
    authorize: true,
    checkVisible: false,
    active: true,
    keyStorage: "",
    userAccess: ["1", "2", "3","5"],
    class: 'blue',
} ]